import { Badge } from '@/components/ui';
import type { ProbationStatus } from '@/api/services/probation.service';

const TONES: Record<ProbationStatus, 'success' | 'warning' | 'danger' | 'neutral' | 'info'> = {
  open: 'info',
  review_submitted: 'info',
  extended: 'warning',
  confirmed: 'success',
  ended: 'danger',
  cancelled: 'neutral',
};

const LABELS: Record<ProbationStatus, string> = {
  open: 'Open',
  review_submitted: 'Reviewed',
  extended: 'Extended',
  confirmed: 'Confirmed',
  ended: 'Ended',
  cancelled: 'Cancelled',
};

export function ProbationStatusBadge({ status }: { status: ProbationStatus }): React.ReactElement {
  return (
    <Badge variant={TONES[status] ?? 'neutral'} size="sm">
      {LABELS[status] ?? String(status).replaceAll('_', ' ')}
    </Badge>
  );
}
